export const rankTabs = [
  { key: "realtime", label: "实时热度" },
  { key: "today", label: "今日榜单" },
  { key: "week", label: "本周盘点" },
];

export const rankBoards = {
  realtime: [
    { id: "1001", title: "跨年舞台彩排花絮流出，三组嘉宾同框画面被反复放大", heat: 982340, trend: "up", tag: "现场直播" },
    { id: "1003", title: "音乐节散场地铁合唱刷屏，实时楼记录了一整个夜晚", heat: 812650, trend: "up", tag: "实时楼" },
    { id: "1002", title: "古装剧路透更新，主角同款造型被指戏外也挺默契", heat: 874120, trend: "flat", tag: "路透" },
    { id: "1004", title: "主播口头禅被二创成歌，一周内成了最出圈的热梗", heat: 768900, trend: "up", tag: "二创" },
    { id: "1005", title: "综艺名场面重剪版传播，节目组回应剪辑争议", heat: 701220, trend: "down", tag: "官方回应" },
    { id: "1006", title: "电影发布会后台采访流出，主创回应角色争议", heat: 655400, trend: "flat", tag: "发布会" },
    { id: "1007", title: "巡演加场官宣，开票前粉丝自发整理观演攻略", heat: 612700, trend: "up", tag: "巡演" },
    { id: "1008", title: "短剧团队换角传闻发酵，制片方发声明澄清", heat: 588300, trend: "down", tag: "澄清声明" },
  ],
  today: [
    { id: "1002", title: "古装剧路透更新，主角同款造型被指戏外也挺默契", heat: 874120, trend: "flat", tag: "路透" },
    { id: "1001", title: "跨年舞台彩排花絮流出，三组嘉宾同框画面被反复放大", heat: 982340, trend: "up", tag: "现场直播" },
    { id: "1004", title: "主播口头禅被二创成歌，一周内成了最出圈的热梗", heat: 768900, trend: "up", tag: "二创" },
    { id: "1006", title: "电影发布会后台采访流出，主创回应角色争议", heat: 655400, trend: "up", tag: "发布会" },
    { id: "1003", title: "音乐节散场地铁合唱刷屏，实时楼记录了一整个夜晚", heat: 812650, trend: "flat", tag: "实时楼" },
    { id: "1009", title: "城市夜跑团直播意外出圈，评论区变成大型认亲现场", heat: 542100, trend: "up", tag: "直播" },
    { id: "10010", title: "颁奖礼红毯生图合集更新，造型盘点帖热度攀升", heat: 498700, trend: "flat", tag: "红毯" },
    { id: "1005", title: "综艺名场面重剪版传播，节目组回应剪辑争议", heat: 701220, trend: "down", tag: "官方回应" },
  ],
  week: [
    { id: "1004", title: "主播口头禅被二创成歌，一周内成了最出圈的热梗", heat: 768900, trend: "up", tag: "二创" },
    { id: "1001", title: "跨年舞台彩排花絮流出，三组嘉宾同框画面被反复放大", heat: 982340, trend: "flat", tag: "现场直播" },
    { id: "1009", title: "城市夜跑团直播意外出圈，评论区变成大型认亲现场", heat: 542100, trend: "up", tag: "直播" },
    { id: "1003", title: "音乐节散场地铁合唱刷屏，实时楼记录了一整个夜晚", heat: 812650, trend: "down", tag: "实时楼" },
    { id: "1007", title: "巡演加场官宣，开票前粉丝自发整理观演攻略", heat: 612700, trend: "up", tag: "巡演" },
    { id: "1002", title: "古装剧路透更新，主角同款造型被指戏外也挺默契", heat: 874120, trend: "down", tag: "路透" },
    { id: "1008", title: "短剧团队换角传闻发酵，制片方发声明澄清", heat: 588300, trend: "flat", tag: "澄清声明" },
    { id: "10010", title: "颁奖礼红毯生图合集更新，造型盘点帖热度攀升", heat: 498700, trend: "up", tag: "红毯" },
  ],
};

export const tickerItems = [
  "跨年舞台彩排花絮实时楼已更新至第六条",
  "音乐节散场地铁合唱话题进入今日榜单前三",
  "综艺剪辑争议节目组发布正式说明",
  "热梗档案馆新增主播口头禅二创条目",
  "巡演加场观演攻略文档已同步至分类页",
];